import { render, staticRenderFns } from "./enterpriseFooter.vue?vue&type=template&id=b1d56e48&scoped=true&"
import script from "./enterpriseFooter.vue?vue&type=script&lang=js&"
export * from "./enterpriseFooter.vue?vue&type=script&lang=js&"
import style0 from "./enterpriseFooter.vue?vue&type=style&index=0&id=b1d56e48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1d56e48",
  null
  
)

export default component.exports